import React from 'react';
import { ReportingShellContext } from '../../common';
import {
    TemplateDetailContainerProps,
    TemplateDetailViewProps,
} from './templateDetailProps';
import {
    TemplateDetailController,
    TemplateDetailLoader,
} from './templateDetailInterface';
import { ReportingShellContainerBaseConfig } from '../../../base';
import { useNavigate } from 'react-router';

export function createTemplateDetailContainer(
    config: ReportingShellContainerBaseConfig,
    loader: TemplateDetailLoader,
    controller: TemplateDetailController,
    View: React.FC<TemplateDetailViewProps>
): React.FC<TemplateDetailContainerProps> {
    const {
        context: { useContext },
        repository,
        kernel: {
            infra: {
                toaster: { useToast },
            },
        },
        external: {
            integration: { open: openIntegration },
        },
        state: states,
    } = config;

    return states.insert.subscribe(({ overlay, ...containerProps }) => {
        const context = useContext();
        const navigate = useNavigate();
        // Load the template data
        const data = loader.useLoad(context, containerProps);
        const state = states.insert.useState(context);

        // Set up mutations for integration management
        const mutation = {
            integration: {
                upsert: repository.platform.integration.useUpsert(context),
            },
        };

        // Transform data for the view
        const props = controller.useProps(context, data, {
            async onInstall() {
                // Upsert the integration for this template (create or update if exists)
                const response = await mutation.integration.upsert.mutateAsync({
                    workspace_id: context.workspace.id,
                    definition_id: data.item.definition.id,
                    configuration: {}, // Default empty configuration
                });

                console.log('navigating to integration', response);
                openIntegration(
                    {
                        integration: response,
                        tool: data.item.tool,
                    },
                    {
                        navigate,
                    }
                );
                state.onChange({
                    overlay: {
                        isOpen: false,
                    },
                });
            },
            isInstalling: mutation.integration.upsert.isLoading,
        });

        return <View {...props} overlay={overlay} />;
    });
}
